var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 999.99 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 596,
    y1: 2109.06,
    x2: 596,
    y2: 3109.06,
    gradientTransform: "translate(-96 3109.06) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a300cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3467f4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500,1000c276.14,0,499.99-223.86,499.99-500S776.14,0,500,0,0,223.86,0,500s223.86,500,500,500Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.07,756.27c125.66-165.62,111.29-393.64-23.45-542.25l-20.2,26.64c120.47,137.18,132.1,344.61,17.46,495.71-114.64,151.1-317.52,195.8-482.09,116.68l-20.2,26.64c179.44,89.74,402.87,42.2,528.53-123.47l-.05.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.28,757.86c-120.47-137.18-132.1-344.61-17.46-495.71,114.64-151.1,317.52-195.8,482.09-116.68l20.2-26.64C510.67,29.09,287.24,76.63,161.58,242.3c-125.66,165.62-111.29,393.64,23.45,542.25l20.2-26.64.05-.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M671.57,396.18h-55.47c-6.19,0-12.32-2.79-16.81-7.28l-22.4-25.24c-6.73-7.28-17.36-7.83-25.24-1.7l-1.7,1.7-19.06,21.85c-6.19,7.28-15.71,11.22-25.24,11.22H202.4c-8.43,24.64-14.02,51.03-16.26,77.37h286.99c5.04,0,10.08-2.24,13.47-5.59l26.89-28.03c3.34-3.34,7.83-5.59,12.87-5.59h1.1c5.04,0,10.08,2.24,13.47,6.18l22.4,25.24c4.49,5.04,10.67,7.83,16.81,7.83h233.71c-2.25-26.34-7.83-52.68-16.26-77.37h-126.11v-.55l.1-.05ZM487.69,550.93l-22.4-25.24c-6.73-7.28-17.36-7.83-25.24-1.7l-1.7,1.7-19.6,21.85c-6.19,7.28-15.11,11.22-24.64,11.22h-203.48c5.04,26.89,14.02,53.23,25.79,78.47h142.92c5.04,0,9.53-2.25,13.47-5.59l26.89-28.04c3.34-3.34,7.83-5.59,12.87-5.59h1.1c5.04,0,10.08,2.25,13.47,6.19l22.4,25.24c4.49,5.04,10.67,7.83,16.81,7.83h317.27c11.77-24.64,20.75-51.03,25.79-78.47h-304.9c-6.73,0-12.87-2.79-16.81-7.83v-.05ZM597.54,306.54l26.89-28.04c3.34-3.34,7.83-5.59,12.87-5.59h1.1c5.04,0,10.08,2.25,13.47,5.59l22.4,25.24c4.49,5.04,10.62,7.28,16.81,7.28h60.56c-105.36-139.03-303.25-166.47-442.83-61.66-23,17.36-43.7,38.11-61.66,61.66h336.87c5.59,1.1,10.08-1.1,13.47-4.49h.05ZM380.63,714.6c-6.73,0-12.87-2.79-16.81-7.28l-22.4-25.24c-6.73-7.28-17.96-7.83-25.24-1.1l-1.1,1.1-19.6,21.85c-6.19,7.28-15.11,11.22-24.64,11.22h-1.1c118.28,126.66,318.37,132.84,445.62,13.47,5.04-4.49,9.53-9.53,14.57-14.57h-349.2v.55h-.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStApt);
export default __webpack_public_path__ + "static/media/stAPT.990c40b80fb26df81201f8094b8f9897.svg";
export { ForwardRef as ReactComponent };